import $ from 'jquery';
import _ from 'underscore';
import BaseView from 'picnic/core/views/Base';
import Slideshow from 'picnic/Slideshow';
import ErrorView from 'app/cms/survey/views/Error';


class View extends BaseView {

	constructor(options) {
		super(options);

		_.bindAll(
			this,
			'_onContinue'
		);
	}

	render() {
		this._renderStepSlideshow();

		return this;
	}

	events() {
		return {
			'click .next-step': this._onContinue,
			'submit': this._onSubmitForm,
		};
	}

	_renderStepSlideshow() {
		this._slideshow = new Slideshow({
			el: this.$el.find('.slideshow'),
			context: this.context,
			settings: {
				fade: true,
				swipe: false
			}
		}).render();
	}

	_renderError(errorMessages) {
		var
			currentSlideIndex = this._slideshow.slideshow.currentSlide,
			currentSlide = this._slideshow.slideshow.$slides[currentSlideIndex]
		;

		this._error = new ErrorView({
			el: $(currentSlide).find('h3'),
			context: this.context,
			errorMessages: errorMessages
		}).render();

		this._slideshow.resize();
	}

	_submitForm() {
		var
			self = this
		;

		if (this._error) {
			this._error.destroy();
		}

		$.post(this.el.action, this.$el.serialize() + '&article=' + window.kleinanzeigen.articleId, function(data) {
			if (data.success === true) {
				self._slideshow.slideshow.goTo(self._slideshow.slideshow.slideCount);
			} else {
				self._renderError(_.values(data.error_list));
			}
		});
	}

	_onContinue(event) {
		event.preventDefault();

		var
			checked = this.$el.find('.step-1').find('input:checked')
		;

		if (this._error) {
			this._error.destroy();
		}

		if (checked.val() === 'True') {
			this._submitForm();
		} else if (checked.val() === 'False') {
			this._slideshow.next();
		} else {
			this._renderError(['Bitte wähle eine Antwort aus.']);
		}
	}

	_onSubmitForm(event) {
		event.preventDefault();

		this._submitForm();
	}

}

export default View;
